import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { PRODUCT_URL } from '../data/article';
interface CtaButtonProps {
  label: string;
  size?: 'default' | 'compact';
}
export function CtaButton({
  label,
  size = 'default'
}: CtaButtonProps) {
  const isCompact = size === 'compact';
  const handleClick = () => {
    const win = window as any;
    if (win.fbq) {
      win.fbq('trackCustom', 'CTAClick');
    }
  };
  return <a href={PRODUCT_URL} onClick={handleClick} className={['group flex w-full items-center justify-center gap-2 rounded-md bg-forest-mid text-center font-sans font-semibold text-white shadow-sm', 'transition-colors duration-150 ease-out hover:bg-forest focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-forest', isCompact ? 'px-4 py-3 text-sm' : 'px-6 py-4 text-base sm:text-lg'].join(' ')} data-id="element-32" data-mp="qj92ytmzq38h">
      <span data-id="element-33" data-mp="15areae4wn9li">{label}</span>
      <ArrowRightIcon className={['shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1', isCompact ? 'h-4 w-4' : 'h-5 w-5'].join(' ')} aria-hidden="true" data-id="element-34" data-mp="157ddhabw38g6" />
    </a>;
}